import {HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AdminService} from '../services/admin.service';
import {HTTP_STATUS_CODES} from '../shared.constants/all-constants';
import {END_OF_DAY_SUFFIX, START_OF_DAY_SUFFIX} from './report-datepicker.constants';
import {applyReportDatepickerError} from './report-datepicker-error.state';
import {ReportDatepickerReportPresenter} from './report-datepicker-report.presenter';
import {
  ReportDatepickerError,
  ReportDatepickerReportView,
  ReportRequestContext
} from './report-datepicker.types';

@Injectable()
export class ReportDatepickerVectorReportCoordinator {
  constructor(
    private adminService: AdminService,
    private presenter: ReportDatepickerReportPresenter
  ) {
  }

  requestGroup(view: ReportDatepickerReportView, context: ReportRequestContext): void {
    this.adminService.getFullVector(
      this.resolveGroupId(view), context.from + START_OF_DAY_SUFFIX,
      context.to + END_OF_DAY_SUFFIX).subscribe(
      (response: HttpResponse<Object>) => this.processResponse(response),
      (error: ReportDatepickerError) => applyReportDatepickerError(view, error)
    );
  }

  requestAll(view: ReportDatepickerReportView, context: ReportRequestContext): void {
    this.adminService.getFullVectorAll(
      context.from + START_OF_DAY_SUFFIX, context.to + END_OF_DAY_SUFFIX).subscribe(
      (response: HttpResponse<Object>) => this.processResponse(response),
      (error: ReportDatepickerError) => applyReportDatepickerError(view, error)
    );
  }

  navigateToDashboard(): void {
    this.presenter.navigateToDashboard();
  }

  private processResponse(response: HttpResponse<Object>): void {
    if (response.status === HTTP_STATUS_CODES.OK) {
      this.presenter.showVector(response.body);
    }
  }

  private resolveGroupId(view: ReportDatepickerReportView): Object {
    return view.groupId.id || view.groupId;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/report-datepicker-vector-report.coordinator.ts